const diff = function(obj1: any, obj2: any) {
  // Make sure an object to compare is provided
  if (!obj2 || Object.prototype.toString.call(obj2) !== '[object Object]') {
    return obj1;
  }

  //
  // Compare our objects
  //
  let key;
  let diffs = {};

  // Loop through the first object
  for (key in obj1) {
    if (obj1.hasOwnProperty(key)) {
      compare(obj1[key], obj2[key], key, diffs);
    }
  }

  return diffs;
};

const compare = function(item1: any, item2: any, key: any, diffs: any) {
  // Get the object type
  var type1 = Object.prototype.toString.call(item1);
  var type2 = Object.prototype.toString.call(item2);

  if (type2 === '[object Undefined]') {
    return;
  }

  // If items are different types
  if (type1 !== type2) {
    diffs[key] = item2;
    return;
  }

  // If an object, compare recursively
  if (type1 === '[object Object]') {
    var objDiff = diff(item1, item2);
    if (Object.keys(objDiff).length > 0) {
      diffs[key] = objDiff;
    }
    return;
  }

  // Else if it's a function, convert to a string and compare
  // Otherwise, just compare
  if (type1 === '[object Function]') {
    if (item1.toString() !== item2.toString()) {
      diffs[key] = item2;
    }
  } else {
    if (item1 !== item2) {
      diffs[key] = item2;
    }
  }
};

export default diff;
